import React from 'react';
import { UserAuth } from '../context/AuthContext';
import { toast, Toaster } from "react-hot-toast";
import Popup from 'reactjs-popup';
import '../popup.css';
import { Navigate } from 'react-router-dom';
const Account = () => {
  const { logOut, user, deleteAccount } = UserAuth();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };
  const handleDeleteAccount = async () => {
    try {
      await deleteAccount();
      toast.success('Account deleted Succesfully')

      await logOut();
    } catch (error) {

    }
  }
const handleCancelDeletion=async ()=>{
  window.location.reload()
}
  return (
    <div>
      <Toaster toastOptions={{ duration: 4000 }} />
      <div className='w-[500px] m-auto'>

        <h1 className='text-center text-2xl font-bold pt-12'>Delete account</h1>
        <div>
          <center>
            <p>Are you sure you want to delete your account {user.name} from iTok?</p>
    
            <div >
              <Popup trigger={<button onClick={handleDeleteAccount} className='border py-2 px-5 mt-10'>Delete Accout</button>} position="center">
                <div className='popup'>
                  <div class="modal_item s_modal">
                    <div class="modal_body">

                      <div class="s_text">
                        <h2>Delete Confirmation</h2>
                        <p>Are you sure you want to delete your account ?</p>
                      </div>
                    </div>
                    <div class="s_button">
                      <button className='success_btn' onClick={handleCancelDeletion}>Cancel</button>
                      <button class="error_btn" onClick={handleDeleteAccount}>Confirm</button>
                    </div>
                  </div>
                </div>
              </Popup></div>
          </center>
        </div>
      </div></div>
  );
};

export default Account;
